import React from "react";
import { Dialog } from "@headlessui/react";

export default function GlobalItemSelectorModal({
  open,
  onClose,
  groupedGlobalItems,
  addingItemId,
  onAddItem,
}: {
  open: boolean;
  onClose: () => void;
  groupedGlobalItems: [string, any[]][];
  addingItemId: string | null;
  onAddItem: (itemId: string) => void;
}) {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/60" aria-hidden="true" />

      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4">
          <Dialog.Panel className="relative max-h-[90vh] w-full max-w-2xl bg-[#161b27] rounded-2xl border border-[#2a3347] flex flex-col">
            {/* Header */}
            <div className="sticky top-0 z-10 bg-[#161b27] px-6 pt-5 pb-3 border-b border-[#2a3347] flex justify-between items-center rounded-t-2xl">
              <Dialog.Title className="text-sm font-semibold text-slate-100">
                ➕ Bestehende Items hinzufügen
              </Dialog.Title>
              <button
                onClick={onClose}
                className="text-slate-600 hover:text-slate-300 text-xl transition-colors"
                title="Schließen"
              >
                &times;
              </button>
            </div>

            {/* Scrollbarer Bereich */}
            <div className="overflow-y-auto px-6 pb-6 space-y-5 mt-4">
              {groupedGlobalItems.length === 0 ? (
                <p className="text-slate-500 text-sm italic">
                  Keine weiteren Items verfügbar.
                </p>
              ) : (
                groupedGlobalItems.map(([catName, items]) => (
                  <div key={catName}>
                    <h3 className="text-[10px] uppercase tracking-widest text-slate-600 mb-2">{catName}</h3>
                    <ul className="space-y-1.5">
                      {items.map((item) => (
                        <li
                          key={item.id}
                          className="flex justify-between items-center bg-[#1e2639] border border-[#2a3347] rounded-xl px-3 py-2.5"
                        >
                          <span className="text-sm text-slate-300">{item.name}</span>
                          <button
                            onClick={() => onAddItem(item.id)}
                            disabled={addingItemId === item.id}
                            className="text-xs px-3 py-1 rounded-full bg-sky-600 text-white hover:bg-sky-500 transition-colors disabled:opacity-50"
                          >
                            {addingItemId === item.id ? "Wird hinzugefügt…" : "Hinzufügen"}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))
              )}
            </div>
          </Dialog.Panel>
        </div>
      </div>
    </Dialog>
  );
}
